import clsx from 'clsx';
import {
	Dialog as PrimeDialog,
	type DialogProps as PrimeDialogProps,
} from 'primereact/dialog';
import type { ReactNode } from 'react';
import dialogModule from './dialog.module.css';

interface DialogProps extends PrimeDialogProps {
	children?: ReactNode;
	header?: PrimeDialogProps['header'];
	visible?: PrimeDialogProps['visible'];
	onHide: PrimeDialogProps['onHide'];
	className?: PrimeDialogProps['className'];
	pt?: PrimeDialogProps['pt'];
	draggable?: boolean;
	thin?: boolean;
}

const Dialog = ({
	children,
	header,
	visible,
	onHide,
	className,
	pt,
	draggable = false,
	thin = false,
	...rest
}: DialogProps) => {
	return (
		<PrimeDialog
			header={header}
			visible={visible}
			onHide={onHide}
			draggable={draggable}
			className={`${dialogModule.dialog} ${thin ? dialogModule.thinDialog : ''} ${className}`}
			pt={{
				...{
					header: () => ({
						className: dialogModule.header,
					}),
					content: () => ({
						className: clsx(dialogModule.content, header && 'mt-4'),
					}),
					closeButton: () => ({
						className: dialogModule.closeButton,
					}),
				},
				...pt,
			}}
			{...rest}
		>
			{children}
		</PrimeDialog>
	);
};

export default Dialog;
